import { TAMANO_IMAGENES } from "../../utils/constants";
import { startAlerta } from "../ui/alertas";
import { startSpinner, finishSpinner } from "../ui/spinner";
import { setDocumentoEfectorFac, setDocumentoLegal } from "./contratacionesDocumentacion";
import { fileSize } from "../../helpers/filesFunctions";

export const startUploading = (file, idTipoDocumentacion, documentacionLegal) => {
  return async (dispatch, getState) => {
    dispatch(startSpinner());
    if (file?.size <= TAMANO_IMAGENES.DOCUMENTACION_AFILIADOS) {
      const formData = new FormData();
      formData.append("files", file);
      
      if(documentacionLegal){
        dispatch(setDocumentoLegal(formData, idTipoDocumentacion));
      }else{
        dispatch(setDocumentoEfectorFac(formData, idTipoDocumentacion));
      }
    } else {
      dispatch(
        startAlerta(
          `El archivo no puede ser mayor a: ${fileSize(
            TAMANO_IMAGENES.DOCUMENTACION_AFILIADOS
          )} y el mismo tiene: ${fileSize(file.size)}`,
          "info"
        )
      );
    }
    dispatch(finishSpinner());
  };
};
